



















































































































































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import DocumentApiHead from '@/data/DocumentApiData';
import { getModule } from 'vuex-module-decorators';
import DocumentModule from '@/store/modules/Document';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';

@Component({
  components: {
    Table,
  },
})
export default class TransferKey extends Mixins(ErrorHandleMixin) {
  DocumentInstance = getModule(DocumentModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  TableHead: Array<object> = [...DocumentApiHead.TableHead]

  modalAddDocument = false

  isOpenRemove = false

  currentSelection: any = {};

  data = []

  provider = ''

  docSeamless = ''

  docTransfer = ''

  assetGame = ''

  getToken: any

  assetGameMulticurrency = ''

  userCurrency: any = {};

  isMultiCurrency = true;

  created() {
    this.fetchDocumentApi();
  }

  async fetchDocumentApi() {
    this.getToken = jwt_decode(this.AuthInstance.tokenRefresh);
    this.userCurrency = this.getToken.currency;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.DocumentInstance.FetchDocumentApi();
    this.data = this.DocumentInstance.documentApi;
    if (res.code) {
      this.checkError(res);
    }
    if (['ADMIN', 'SUPERADMIN', 'SUBCOMPANY'].includes(this.AuthInstance.user.role)) {
      this.isMultiCurrency = true;

      this.TableHead[0] = [...DocumentApiHead.TableHead[0]];
    } else if (this.userCurrency !== 'THB') {
      this.isMultiCurrency = true;
      this.TableHead[0] = [...DocumentApiHead.TableHead[0]]
        .filter((item: any) => !item.isTHB).filter((item: any) => !item.isAgentHidden);
    } else {
      this.isMultiCurrency = false;
      this.TableHead[0] = [...DocumentApiHead.TableHead[0]]
        .filter((item: any) => !item.isMulticurrency).filter((item: any) => !item.isAgentHidden);
    }
    this.GeneralInstance.toggleLoading(false);
    this.modalAddDocument = false;
  }

  async createUrl() {
    this.GeneralInstance.toggleLoading(true);
    const createUrl = {
      provider: this.provider,
      urlDocSeamless: this.docSeamless,
      urlDocTransfer: this.docTransfer,
      urlAssetGame: this.assetGame,
      urlAssetGameMulticurrency: this.assetGameMulticurrency,
    };
    const res = await this.DocumentInstance.CreateDocumentApi(createUrl);
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.modalAddDocument = false;
    this.provider = '';
    this.docSeamless = '';
    this.docTransfer = '';
    this.assetGame = '';
    this.assetGameMulticurrency = '';
    this.fetchDocumentApi();
  }

  editURL(data) {
    this.modalAddDocument = true;
    this.provider = data.provider;
    this.docSeamless = data.link.seamless;
    this.docTransfer = data.link.transfer;
    this.assetGame = data.link.asset;
    this.assetGameMulticurrency = data.link.asset_multicurrency;
  }

  async remove(item) {
    this.currentSelection = item;
    this.provider = item.provider;
    this.isOpenRemove = true;
  }

  async submitRemove() {
    const res = await this.DocumentInstance.DeleteDocumentApi({
      itemDelete: this.currentSelection._id,
    });
    this.checkError(res);
    this.isOpenRemove = false;
    this.fetchDocumentApi();
  }

  async download(data) {
    if (data.indexOf('http://') === 0 || data.indexOf('https://') === 0) {
      window.open(`${data}`);
    } else {
      window.open(`http://${data}`);
    }
  }

  closeModal() {
    this.modalAddDocument = false;
    this.provider = '';
    this.docSeamless = '';
    this.docTransfer = '';
    this.assetGame = '';
    this.assetGameMulticurrency = '';
  }
}
